import {DG_axiosNormal} from "../../../../custom/axios/normal";
import { notificationCategory } from '../../../../common/config-variable/notification'

const urlCountByEmployeeId = '/dogoo/notification-rest/v2.0/notification-count'
const urlAllNotification = '/dogoo/notification-rest/v2.0/notification'
const urlTypeNotification = '/dogoo/notification-rest/v2.0/notification/approval-type'
const urlNotificationProcess =
    'dogoo/process-gateway-rest/v2.0/process/notify/assignee'

export async function getCountNotificationByEmployeeId(category, type, status, typeReceiver, seen) {
    const response = await DG_axiosNormal.get(urlCountByEmployeeId,
        {
            params: {
                category,
                type,
                status,
                typeReceiver,
                seen
            }
        })
    return response?.data || []
}

export async function getAllNotificationByEmployeeId(category,type,status,pageSize,page ) {
    const response = await DG_axiosNormal.get(
        urlAllNotification
        , {
            params: {
                category,
                type,
                status,
                pageSize,
                page
            }
        })
    return response?.data || []
}
export async function updateStatusNotification(id, value) {
    const response = await DG_axiosNormal.put(urlAllNotification + `/${id}`, value)
    return response?.data || []
}

export async function getAllButtonProcessInNotify(queryObjects) {
    const response = await DG_axiosNormal.post(urlNotificationProcess, {
        queryObjects: queryObjects
    })
    return response?.data || []
}

export async function updateTypeNotification(id, type) {
    const response = await DG_axiosNormal.put(urlTypeNotification + `/${id}`, type)
    return response?.data || []
}

export async function updateStatusNotificationByReceiverIdAndDoEntryIdAndNameAndCategory(
    receiverId,
    doEntryId,
    name,
    category,
    value) {
    const response = await DG_axiosNormal.put(urlAllNotification +
        `/by-receiver/${receiverId}/by-entry/${doEntryId}/by-name/${name}/by-category/${category}`, value)
    return response?.data || []
}

export async function updateSeenAllNotificationByReceiverId(
    receiverId,
    data
) {
    const response = await DG_axiosNormal.put(
        urlAllNotification + `/approval-seen-by-receiver/${receiverId}`,
        data,
        {
            params: {
                category: "all",
            }
        }
    )
    return response?.data || []
}

export async function updateStatusAllNotificationByReceiverId(
    receiverId,
    value) {
    const response = await DG_axiosNormal.put(urlAllNotification +
        `/approval-all-by-receiver/${receiverId}`, value, {
        params: {
            category: notificationCategory,
            type: 'notification'
        }
    })
    return response?.data || []
}

export async function getActionNotification(actionUrl, config) {
    const response = await DG_axiosNormal.get(actionUrl, config)
    return response?.data || []
}

export async function postActionNotification(actionUrl, payload, config) {
    const response = await DG_axiosNormal.post(actionUrl, payload, config)
    return response?.data || []
}

export async function putActionNotification(actionUrl, payload, config) {
    const response = await DG_axiosNormal.put(actionUrl, payload, config)
    return response?.data || []
}

export async function patchActionNotification(actionUrl, payload, config) {
    const response = await DG_axiosNormal.patch(actionUrl, payload, config)
    return response?.data || []
}

export async function deleteActionNotification(actionUrl, config) {
    const response = await DG_axiosNormal.delete(actionUrl, config)
    return response?.data || []
}